import React from "react";
import { GolfHeaderContainer } from "../organisms/golfHeaderContainer";
import { GolfLoginContainer } from "../organisms/golfLoginContainer";
import { useMedia } from "use-media";
import GolfReservationCheckContainer from "../organisms/golfReservationCheckContainer";
import GolfLoginCheck from "../../util/golfLoginCheck";


export const GolfReservationCheckTemplate = (props) => {

  //レスポンシブ対応
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const isWideTablet = useMedia({ maxWidth: "960px" });

  return (
    <div style={isWideTablet ? styles.loginWrapSp : styles.loginWrapPc}>
      <GolfHeaderContainer 
        Label categoryLabel1={"ゴルフ予約確認"} 
        categoryLabel2={"GOLF"}
        reserveCheck={true}
        path={"/reserve/top"}/>
        <GolfLoginCheck />
      <GolfReservationCheckContainer 
        location={props.location}
      />
    </div>
  );
}

const styles = {
  loginWrapPc: {
    height: "100vh",
    overflow: "auto",
    display: "flex",
    flexDirection: "column"
  },
  loginWrapSp: {
    height: "100vh",
    overflow: "auto",
    display: "flex",
    flexDirection: "column"
  },
}

export default GolfReservationCheckTemplate;
